import Cookie from 'js-cookie';
import { COOKIE_KEYS } from './constant';
export function getCookie(cname: string) {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

const getTopCookieDomain = (hostname: string) => {
  // This allows us to use cookies on localhost for development
  if (['localhost', '0.0.0.0', '0.0'].includes(hostname)) {
    return hostname;
  }

  const parts = hostname.split('.');
  const topDomain = parts.slice(parts.length - 2).join('.');
  return `.${topDomain}`;
};

export const defaultCookieOptions = (
  useSecureCookies: boolean,
  hostname: string,
) => ({
  // Change this to true once the backend support reading the tokens from the cookies
  httpOnly: false,
  sameSite: (useSecureCookies ? 'none' : 'lax') as
    | 'lax'
    | 'strict'
    | 'none'
    | undefined,
  path: '/',
  secure: useSecureCookies,
  domain: getTopCookieDomain(hostname),
});

const useSecureCookies = () => {
  return window.location.protocol === 'https:';
};

export function clearCookies() {
  const { sameSite, secure, domain, path } = defaultCookieOptions(
    useSecureCookies(),
    getTopCookieDomain(window.location.hostname),
  );
  Cookie.remove(COOKIE_KEYS.AC_TOKEN, {
    sameSite,
    secure,
    domain,
    path,
  });
  Cookie.remove(COOKIE_KEYS.AC_REFRESH_TOKEN, {
    sameSite,
    secure,
    domain,
    path,
  });
}

export const setCookie = (name: string, value: string, expires?: Date) => {
  const cookieOptions = defaultCookieOptions(
    useSecureCookies(),
    getTopCookieDomain(window.location.hostname),
  );
  Cookie.set(name, value, {
    ...cookieOptions,
    ...(expires ? { expires } : {}),
  });
};
